import actionTypes from './actionTypes';

const INITIAL_STATE = {
  loading: false,
  failed: false,
  error: false,
  message: null,

  financialTransactionDetailsLoading: false,
  financialTransactionDetailsFailed: false,
  financialTransactionDetailsError: false,
  financialTransactionDetailsMessage: null,
  financialTransactions: {},
  financialTransactionsList: [],

  userFinancialTransactions: {},
  userFinancialTransactionsList: [],

  getConstantReservesReportLoading: false,
  getConstantReservesReportFailed: false,
  getConstantReservesReportError: false,
  getConstantReservesReportMessage: null,
  constantReservesList: [],
  constantReservesListTotalRecords: '',

  getRechargeChairsReportLoading: false,
  getRechargeChairsReportFailed: false,
  getRechargeChairsReportError: false,
  getRechargeChairsReportMessage: null,
  rechargeChairsReportList: [],
  rechargeChairsReportListTotalRecords: 0,

  getPurchasePackagesReportLoading: false,
  getPurchasePackagesReportFailed: false,
  getPurchasePackagesReportError: false,
  getPurchasePackagesReportMessage: '',
  purchasePackagesReportList: [],
  purchasePackagesReportListTotalRecords: 0,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FINANCIAL_TRANSACTIONS_LOADING:
      return {
        ...state,
        loading: true,
        failed: false,
        error: false,
        message: null,
        financialTransactions: {},
        financialTransactionsList: [],
      };

    case actionTypes.FETCH_FINANCIAL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        financialTransactions: { ...action.payload },
        financialTransactionsList: [...action.payload.financialTransactions],
        loading: false,
        failed: false,
        error: false,
        message: null,
      };
    case actionTypes.FETCH_FINANCIAL_TRANSACTIONS_FAILED:
      return {
        ...state,
        loading: false,
        failed: true,
        error: false,
        message,
        financialTransactions: {},
        financialTransactionsList: [],
      };
    case actionTypes.FETCH_FINANCIAL_TRANSACTIONS_REJECT:
      return {
        ...state,
        loading: false,
        failed: false,
        error: true,
        message: null,
        financialTransactions: {},
        financialTransactionsList: [],
      };
    case actionTypes.FETCH_FINANCIAL_TRANSACTION_DETAILS_LOADING:
      return {
        ...state,
        financialTransactionDetailsLoading: true,
        financialTransactionDetailsFailed: false,
        financialTransactionDetailsError: false,
        financialTransactionDetailsMessage: null,
      };

    case actionTypes.FETCH_FINANCIAL_TRANSACTION_DETAILS_SUCCESS:
      return {
        ...state,
        financialTransactionDetails: action.payload,
        financialTransactionDetailsLoading: false,
        financialTransactionDetailsFailed: false,
        financialTransactionDetailsError: false,
        financialTransactionDetailsMessage: null,
      };
    case actionTypes.FETCH_FINANCIAL_TRANSACTION_DETAILS_FAILED:
      return {
        ...state,
        financialTransactionDetailsLoading: false,
        financialTransactionDetailsFailed: true,
        financialTransactionDetailsError: false,
        financialTransactionDetailsMessage,
      };
    case actionTypes.FETCH_FINANCIAL_TRANSACTION_DETAILS_REJECT:
      return {
        ...state,
        financialTransactionDetailsLoading: false,
        financialTransactionDetailsFailed: false,
        financialTransactionDetailsError: true,
        financialTransactionDetailsMessage: null,
      };

    case actionTypes.FETCH_USER_FINANCIAL_TRANSACTIONS_LOADING:
      return {
        ...state,
        loading: true,
        failed: false,
        error: false,
        message: null,
        userFinancialTransactions: {},
        userFinancialTransactionsList: [],
      };

    case actionTypes.FETCH_USER_FINANCIAL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        userFinancialTransactions: { ...action.payload },
        userFinancialTransactionsList: [
          ...action.payload.financialTransactionsByUserId,
        ],
        loading: false,
        failed: false,
        error: false,
        message: null,
      };
    case actionTypes.FETCH_USER_FINANCIAL_TRANSACTIONS_FAILED:
      return {
        ...state,
        loading: false,
        failed: true,
        error: false,
        message,
        userFinancialTransactions: {},
        userFinancialTransactionsList: [],
      };
    case actionTypes.FETCH_USER_FINANCIAL_TRANSACTIONS_REJECT:
      return {
        ...state,
        loading: false,
        failed: false,
        error: true,
        message: null,
        userFinancialTransactions: {},
        userFinancialTransactionsList: [],
      };

    case actionTypes.GET_CONSTANT_RESERVES_REPORT_LOADING: {
      return {
        ...state,
        getConstantReservesReportLoading: true,
        getConstantReservesReportFailed: false,
        getConstantReservesReportError: false,
        getConstantReservesReportMessage: null,
        constantReservesList: [],
        constantReservesListTotalRecords: '',
      };
    }
    case actionTypes.GET_CONSTANT_RESERVES_REPORT_SUCCESS: {
      return {
        ...state,
        getConstantReservesReportLoading: false,
        getConstantReservesReportFailed: false,
        getConstantReservesReportError: false,
        getConstantReservesReportMessage: null,
        constantReservesList: action.payload.reports,
        constantReservesListTotalRecords: action.payload.totalRecords,
      };
    }
    case actionTypes.GET_CONSTANT_RESERVES_REPORT_REJECT: {
      return {
        ...state,
        getConstantReservesReportLoading: false,
        getConstantReservesReportFailed: false,
        getConstantReservesReportError: true,
        getConstantReservesReportMessage: null,
        constantReservesList: [],
        constantReservesListTotalRecords: '',
      };
    }
    case actionTypes.GET_CONSTANT_RESERVES_REPORT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getConstantReservesReportLoading: false,
        getConstantReservesReportFailed: true,
        getConstantReservesReportError: false,
        getConstantReservesReportMessage: message,
        constantReservesList: [],
        constantReservesListTotalRecords: '',
      };
    }

    case actionTypes.GET_RECHARGE_CHAIRS_REPORT_LOADING: {
      return {
        ...state,
        getRechargeChairsReportLoading: true,
        getRechargeChairsReportFailed: false,
        getRechargeChairsReportError: false,
        getRechargeChairsReportMessage: null,
        rechargeChairsReportList: [],
        rechargeChairsReportListTotalRecords: 0,
      };
    }
    case actionTypes.GET_RECHARGE_CHAIRS_REPORT_SUCCESS: {
      return {
        ...state,
        getRechargeChairsReportLoading: false,
        getRechargeChairsReportFailed: false,
        getRechargeChairsReportError: false,
        getRechargeChairsReportMessage: null,
        rechargeChairsReportList: action.payload.reports,
        rechargeChairsReportListTotalRecords: action.payload.totalRecords,
      };
    }
    case actionTypes.GET_RECHARGE_CHAIRS_REPORT_REJECT: {
      return {
        ...state,
        getRechargeChairsReportLoading: false,
        getRechargeChairsReportFailed: false,
        getRechargeChairsReportError: true,
        getRechargeChairsReportMessage: null,
        rechargeChairsReportList: [],
        rechargeChairsReportListTotalRecords: 0,
      };
    }
    case actionTypes.GET_RECHARGE_CHAIRS_REPORT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getRechargeChairsReportLoading: false,
        getRechargeChairsReportFailed: true,
        getRechargeChairsReportError: false,
        getRechargeChairsReportMessage: message,
        rechargeChairsReportList: [],
        rechargeChairsReportListTotalRecords: 0,
      };
    }

    case actionTypes.GET_PURCHASE_PACKAGES_REPORT_LOADING: {
      return {
        ...state,
        getPurchasePackagesReportLoading: true,
        getPurchasePackagesReportFailed: false,
        getPurchasePackagesReportError: false,
        getPurchasePackagesReportMessage: '',
        purchasePackagesReportList: [],
        purchasePackagesReportListTotalRecords: 0,
      };
    }
    case actionTypes.GET_PURCHASE_PACKAGES_REPORT_SUCCESS: {
      return {
        ...state,
        getPurchasePackagesReportLoading: false,
        getPurchasePackagesReportFailed: false,
        getPurchasePackagesReportError: false,
        getPurchasePackagesReportMessage: '',
        purchasePackagesReportList: action.payload.reports,
        purchasePackagesReportListTotalRecords: action.payload.totalRecords,
      };
    }
    case actionTypes.GET_PURCHASE_PACKAGES_REPORT_REJECT: {
      return {
        ...state,
        getPurchasePackagesReportLoading: false,
        getPurchasePackagesReportFailed: false,
        getPurchasePackagesReportError: true,
        getPurchasePackagesReportMessage: '',
        purchasePackagesReportList: [],
        purchasePackagesReportListTotalRecords: 0,
      };
    }
    case actionTypes.GET_PURCHASE_PACKAGES_REPORT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getPurchasePackagesReportLoading: false,
        getPurchasePackagesReportFailed: true,
        getPurchasePackagesReportError: false,
        getPurchasePackagesReportMessage: message,
        purchasePackagesReportList: [],
        purchasePackagesReportListTotalRecords: 0,
      };
    }

    default:
      return state;
  }
};
